import { useNavigate } from "react-router-dom";

function TableBody({ items }) {
  const navigate = useNavigate();
  return (
    <tbody className="divide-y divide-gray-200 bg-white dark:divide-white/10 dark:bg-gray-900">
      {items &&
        items.map((item) => (
          <tr key={item.key}>
            {item.columns.map((column) =>
              column.href ? (
                <td className={column.className}>
                  <button onClick={() => navigate(column.href)}>
                    {column.content}
                  </button>
                </td>
              ) : (
                <td className={column.className}>{column.content}</td>
              ),
            )}
          </tr>
        ))}
    </tbody>
  );
}
export default TableBody;
